import styles from "../../css/curriculum.module.css";
import ParticlesComponent from "../../components/particles/particles";
import AOS from "aos";
import React, { useEffect } from "react";
import "aos/dist/aos.css";
import icons from "../../css/icons.module.css";

export default function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className={styles.containerMain}>
      <div className={styles.particlesContainer}>
        <ParticlesComponent />

        <div className={styles.DinamicBgContainer}>
          {/* Foto */}
          <div className={styles.photoContainer}>
            <div className={styles.containerTitle}>
              <p className={`${styles.titleHomePage} ${styles.typingEffect}`}>
                Aquí nosotros Innovamos
              </p>
            </div>
            <p className={styles.description}>
              "Ilumina el futuro digital con desarrollo web innovador. <br /> En
              Alight, cada línea de código brilla con eficiencia y creatividad."
            </p>
          </div>

          {/* Descripción */}
          <div className={styles.descriptionContainer}>
            <div className={styles.containerTitle}>
              <p className={`${styles.titleHomePage} ${styles.typingEffect}`}>
                Aquí nosotros Innovamos
              </p>
            </div>
            <p className={styles.description}>
              "Ilumina el dad."
            </p>
          </div>

          {/* Slider */}
          <div className={styles.sliderContainer}>
            <div className={styles.containerTitle}>
              <p className={`${styles.titleHomePage} ${styles.typingEffect}`}>
                Aquí va el slider
              </p>
            </div>
            <p className={styles.description}>
              "Ilumina el futuro digital con desarrollo web innovador."
            </p>
          </div>
        </div>

        <div className={styles.logoContainer}>
          <div className={icons.logoAlightHome}></div>
        </div>
      </div>

      <div className={styles.containerBackground}>
        <div className={styles.line}></div>
        <p className={styles.titleEfect}>Alight Software</p>
      </div>








      <div>



      <p className={styles.description}>
              "Ilumina el futuro digital con desarrollo web innovador."
            </p>
      </div>
    </div>
  );
}
